import React from 'react';

const InfoCard = ({card}) => {
    const { id, name, icon, description } = card;
  return (
    <div className={`card p-6 md:card-side shadow-xl`}>
      <figure>
        <img src={icon} alt="" />
      </figure>
      <div className="card-body">
        <h2 className="text-2xl font-semibold">{name}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default InfoCard;